// Componentes
import PhoneFrame from "./PhoneFrame";

// Icones
import { AiOutlineEye } from "react-icons/ai";

// Estilos
import "./loginPreview.css";

/**
 * Previa estatica da tela de login do app app-expo-inteegra-eventos. Cores,
 * textos e proporcoes espelham app/pages/Login/index.js e
 * app/components/Login.js.
 */
export default function LoginPreview({
  primaryColor,
  secondaryColor,
  changeColorsLogin,
  loginTopColor,
  loginBottomColor,
  loginCopyrightColor,
  logoUrl,
  backgroundUrl,
  hasFirstAccess,
}) {
  // a imagem de fundo, quando existe, substitui as duas cores de fundo
  const hasBackground = !!backgroundUrl;

  // no app o fundo do login vem do tema (primary em cima, auxiliar embaixo) e é
  // sobrescrito pelas cores de login quando "Alterar cores do Login?" está ativo
  const topColor =
    (changeColorsLogin ? loginTopColor : primaryColor) || "#092a49";
  const bottomColor =
    (changeColorsLogin ? loginBottomColor : secondaryColor) || "#204f7d";

  // o botão ENTRAR usa theme.ui.buttons, que no tema default é a cor primária
  const buttonColor = primaryColor || "#092a49";

  // no app o copyright usa a cor primária; a cor própria só vale quando as
  // cores de login estão ativas e alguém escolheu uma
  const copyrightColor =
    (changeColorsLogin ? loginCopyrightColor : "") || primaryColor;

  return (
    <PhoneFrame backgroundColor={hasBackground ? "#fff" : bottomColor}>
      {hasBackground && (
        <img
          className="login-preview__background"
          src={backgroundUrl}
          alt="Imagem de fundo da tela de login"
        />
      )}

      <div
        className={
          hasBackground
            ? "login-preview__header login-preview__header--over-background"
            : "login-preview__header"
        }
        style={hasBackground ? undefined : { backgroundColor: topColor }}
      >
        {logoUrl && (
          <img
            className="login-preview__logo"
            src={logoUrl}
            alt="Logo da tela de login"
          />
        )}
      </div>

      <div className="login-preview__content">
        <div className="login-preview__card">
          <span className="login-preview__card-title">Preencha seus Dados</span>

          <span className="login-preview__label">Email</span>
          <div className="login-preview__field">
            <input
              className="login-preview__input"
              type="text"
              placeholder="Digite seu email"
              readOnly
            />
          </div>

          <span className="login-preview__label">Senha</span>
          <div className="login-preview__field">
            <input
              className="login-preview__input"
              type="text"
              placeholder="Digite sua senha"
              readOnly
            />
            <AiOutlineEye className="login-preview__eye" size={12} />
          </div>

          <div className="login-preview__links">
            <span>Esqueceu a Senha?</span>
            {hasFirstAccess && <span>Primeiro Acesso</span>}
          </div>

          <div
            className="login-preview__button"
            style={{ backgroundColor: buttonColor }}
          >
            ENTRAR
          </div>
        </div>

        <span
          className="login-preview__copyright"
          style={{ color: copyrightColor }}
        >
          {`© ${new Date().getFullYear()} Inteegra Eventos.`}
        </span>
      </div>
    </PhoneFrame>
  );
}
